































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountDepositCoolingOffValues from '@/models/Accounts/DepositAccounts/Values/AccountDepositCoolingOffValues';

@Component({ name: 'AccountDepositCoolingOffValuesRead' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    values: AccountDepositCoolingOffValues;

}
